// src/pages/DiCho.js
import React, { useState, useEffect, useCallback } from "react";
import { fetchData, addData, updateData, deleteData } from "../services/api";
import ThucDonTuan from "../components/ThucDonTuan";
import { useThongBao, ThongBao, DangTai, docQuyen, hoiXoa } from "../vo";

// ============================================================
// 🛒 GHI CHÚ ĐI CHỢ (Đợt 5A)
// ------------------------------------------------------------
// Gốc của mục này là một câu chính chủ nhà viết hồi tháng 8:
//   "Con dâu thường đi chợ lần 2 để mua những món 'chết rồi Mẹ ơi,
//    quên mua cái này'."
//
// Màn hình này phục vụ đúng hai khoảnh khắc, và chúng rất khác nhau:
//
//   1. TRONG TUẦN, ở nhà, nhớ ra thì thêm — phải nhanh như ghi vào mẩu giấy.
//      Vì vậy ô nhập nằm SẴN trên đầu, không giấu sau nút "➕ Thêm". Gõ rồi
//      Enter là xong. Bắt bấm một nút để mở biểu mẫu là đã thua mẩu giấy.
//
//   2. CHỦ NHẬT, đang đứng trong chợ, một tay cầm giỏ — chỉ tick. Vì vậy
//      cả dòng là chỗ bấm được, không phải cái ô vuông bé xíu.
//
// ⚠️ Món đã mua KHÔNG biến mất ngay. Nó chuyển xuống khối dưới, gạch ngang,
// mờ đi. Lý do: đang trong chợ mà tick nhầm rồi món biến mất thì không biết
// đường nào mà lần. Máy chủ giữ 7 ngày rồi mới ẩn.
// ============================================================

// ============================================================
// ⚠️⚠️ ĐỪNG BAO GIỜ ĐƯA COMPONENT NÀY VÀO TRONG HÀM DiCho ⚠️⚠️
// ------------------------------------------------------------
// Lần đầu viết trang này, `DongMon` được định nghĩa BÊN TRONG hàm DiCho.
// Nó gây một lỗi thật mà chủ nhà gặp ngay hôm deploy:
//
//   Đang gõ vào ô "ghi chú" thì con trỏ TỰ NHẢY LÊN ô "tên món",
//   và mấy chữ gõ tiếp rơi vào nhầm ô.
//
// Vì sao: hàm nằm trong hàm thì MỖI LẦN VẼ LẠI nó là một hàm MỚI. React so
// sánh bằng danh tính hàm, thấy khác nên nó không vẽ lại dòng cũ mà THÁO HẲN
// dòng đó ra rồi DỰNG MỘT DÒNG MỚI. Ô nhập bị hủy giữa chừng nên mất con trỏ,
// rồi `autoFocus` của ô đầu tiên kéo con trỏ về ô tên món.
//
// Gõ một chữ = tháo và dựng lại toàn bộ danh sách. Ngoài lỗi con trỏ, nó còn
// chậm dần khi danh sách dài ra.
//
// Bộ thử tự động KHÔNG bắt được lỗi này, vì nó gán giá trị thẳng vào ô bằng
// lệnh chứ không đi qua bàn phím — mà con trỏ nhảy chỗ thì chỉ bàn phím mới
// thấy. Muốn thử phải gõ phím thật.
// ============================================================
function DongMon({
  mon,
  dangSua,
  tenSua,
  ghiChuSua,
  onDoiTenSua,
  onDoiGhiChuSua,
  onTick,
  onMoSua,
  onLuuSua,
  onHuySua,
  onXoa,
  suaDuoc,
}) {
  if (dangSua) {
    return (
      <li className="cho-dong cho-dong-sua">
        <input
          type="text"
          value={tenSua}
          onChange={(e) => onDoiTenSua(e.target.value)}
          className="cho-o-sua"
          maxLength={100}
          autoFocus
        />
        <input
          type="text"
          value={ghiChuSua}
          onChange={(e) => onDoiGhiChuSua(e.target.value)}
          placeholder="ghi chú (không bắt buộc)"
          className="cho-o-sua cho-o-sua-phu"
          maxLength={200}
        />
        <button onClick={onLuuSua} className="nut nut-xanh">Lưu</button>
        <button onClick={onHuySua} className="nut nut-xam">Thôi</button>
      </li>
    );
  }

  return (
    <li className={`cho-dong ${mon.da_mua ? "cho-dong-xong" : ""}`}>
      {/* Cả vùng chữ là chỗ bấm — đang cầm giỏ trong chợ thì không ai
          nhắm trúng một ô vuông 16px được. */}
      <button
        type="button"
        className="cho-vung-tick"
        onClick={onTick}
        title={mon.da_mua ? "Bỏ đánh dấu" : "Đánh dấu đã mua"}
      >
        <span className="cho-o-vuong">{mon.da_mua ? "☑" : "☐"}</span>
        <span className="cho-chu">
          <span className="cho-ten">{mon.ten_mon}</span>
          {mon.ghi_chu && <span className="cho-ghi-chu"> · {mon.ghi_chu}</span>}
          <span className="cho-ai">
            {mon.da_mua
              ? ` · ${mon.ten_nguoi_mua || "ai đó"} đã mua`
              : mon.ten_nguoi_them
                ? ` · ${mon.ten_nguoi_them} thêm`
                : ""}
          </span>
        </span>
      </button>

      {suaDuoc && (
        <span className="cho-nut">
          <button onClick={onMoSua} className="btn-edit" title="Sửa">✏️</button>
          <button onClick={onXoa} className="btn-delete" title="Xóa">🗑️</button>
        </span>
      )}
    </li>
  );
}

// Khối "Cần mua" / "Đã mua". Cũng phải nằm NGOÀI, cùng lý do như trên.
function KhoiMon({ tieuDe, ds, lop, veDong, ghiChuCuoi }) {
  if (ds.length === 0) return null;
  return (
    <div className={`cho-khoi ${lop || ""}`}>
      <h4>
        {tieuDe} ({ds.length})
      </h4>
      <ul className="cho-danh-sach">{ds.map(veDong)}</ul>
      {ghiChuCuoi && <p className="cho-ghi-chu-cuoi">{ghiChuCuoi}</p>}
    </div>
  );
}

function DiCho({ user }) {
  const [ds, setDs] = useState([]);
  const [dangTai, setDangTai] = useState(true);

  const [tenMoi, setTenMoi] = useState("");
  const [ghiChuMoi, setGhiChuMoi] = useState("");
  const [moGhiChu, setMoGhiChu] = useState(false);
  const [dangThem, setDangThem] = useState(false);

  const [suaId, setSuaId] = useState(null);
  const [tenSua, setTenSua] = useState("");
  const [ghiChuSua, setGhiChuSua] = useState("");

  // Món hay mua — máy chủ tự đếm từ lịch sử, không phải khai báo trước.
  const [hayMua, setHayMua] = useState([]);

  const { laAdmin, them: coTheThem } = docQuyen(user);

  const { bao, noiBao } = useThongBao();

  const taiLai = useCallback(async () => {
    try {
      const [d, hm] = await Promise.all([
        fetchData("di-cho"),
        // Hỏng riêng phần gợi ý thì KHÔNG được làm hỏng cả trang —
        // danh sách đi chợ mới là thứ người ta cần.
        fetchData("di-cho-hay-mua").catch(() => []),
      ]);
      setDs(Array.isArray(d) ? d : []);
      setHayMua(Array.isArray(hm) ? hm : []);
    } catch (err) {
      noiBao("⚠️ Không tải được ghi chú đi chợ");
    } finally {
      setDangTai(false);
    }
  // `noiBao` khai được vào đây vì nó được ghi nhớ trong useThongBao
  // (useCallback). Thời bản cũ nó là hàm mới mỗi lần vẽ, khai vào đây là
  // tải lại danh sách vô tận.
  }, [noiBao]);

  useEffect(() => {
    taiLai();
  }, [taiLai]);

  const themMon = async (e) => {
    if (e) e.preventDefault();
    const ten = tenMoi.trim();
    if (ten === "") return;
    setDangThem(true);
    try {
      await addData("di-cho", { ten_mon: ten, ghi_chu: ghiChuMoi.trim() });
      setTenMoi("");
      setGhiChuMoi("");
      setMoGhiChu(false);
      await taiLai();
      // KHÔNG hiện thông báo "đã thêm" — món hiện ngay trong danh sách rồi,
      // nói thêm một câu nữa chỉ tổ che mất chỗ và làm chậm người đang gõ
      // liên tiếp mấy món.
    } catch (err) {
      noiBao("⚠️ Không thêm được món này");
    } finally {
      setDangThem(false);
    }
  };

  // Chạm một cái là món vào danh sách. Không mở biểu mẫu, không hỏi lại —
  // đúng tinh thần "nhanh như mẩu giấy". Bấm nhầm thì có nút 🗑️.
  const themNhanh = async (ten) => {
    try {
      await addData("di-cho", { ten_mon: ten, ghi_chu: "" });
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không thêm được món này");
    }
  };

  const doiTick = async (mon) => {
    try {
      await updateData("di-cho", `${mon.id}/${mon.da_mua ? "chua-mua" : "mua"}`, {});
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không đổi được đánh dấu");
    }
  };

  const moSua = (mon) => {
    setSuaId(mon.id);
    setTenSua(mon.ten_mon || "");
    setGhiChuSua(mon.ghi_chu || "");
  };

  const luuSua = async (mon) => {
    const ten = tenSua.trim();
    if (ten === "") {
      noiBao("⚠️ Tên món không được để trống");
      return;
    }
    try {
      await updateData("di-cho", mon.id, { ten_mon: ten, ghi_chu: ghiChuSua.trim() });
      setSuaId(null);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không sửa được món này");
    }
  };

  const xoaMon = async (mon) => {
    if (!hoiXoa("món", mon.ten_mon)) return;
    try {
      await deleteData("di-cho", mon.id);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không xóa được — chỉ người đã thêm mới xóa được món này");
    }
  };

  if (dangTai) return <DangTai gi="ghi chú đi chợ" />;

  const chuaMua = ds.filter((m) => !m.da_mua);
  const daMua = ds.filter((m) => m.da_mua);

  // Sửa/xóa: chỉ người đã thêm, hoặc admin. Giống Việc nhà — ai đặt ra
  // thì người đó sửa đề bài.
  const veDong = (mon) => (
    <DongMon
      key={mon.id}
      mon={mon}
      dangSua={suaId === mon.id}
      tenSua={tenSua}
      ghiChuSua={ghiChuSua}
      onDoiTenSua={setTenSua}
      onDoiGhiChuSua={setGhiChuSua}
      onTick={() => doiTick(mon)}
      onMoSua={() => moSua(mon)}
      onLuuSua={() => luuSua(mon)}
      onHuySua={() => setSuaId(null)}
      onXoa={() => xoaMon(mon)}
      suaDuoc={laAdmin || mon.nguoi_them === user.id}
    />
  );

  return (
    <div className="card">
      <h3>🛒 Ghi chú đi chợ</h3>
      <ThongBao bao={bao} />

      {coTheThem ? (
        <form onSubmit={themMon} className="cho-form">
          <div className="cho-hang-nhap">
            <input
              type="text"
              value={tenMoi}
              onChange={(e) => setTenMoi(e.target.value)}
              placeholder="Hết gì thì gõ vào đây rồi bấm Enter…"
              maxLength={100}
              className="cho-o-them"
            />
            <button
              type="submit"
              className="nut nut-xanh"
              disabled={dangThem || tenMoi.trim() === ""}
            >
              {dangThem ? "…" : "Thêm"}
            </button>
          </div>
          {moGhiChu ? (
            <input
              type="text"
              value={ghiChuMoi}
              onChange={(e) => setGhiChuMoi(e.target.value)}
              placeholder="Ghi chú: loại nào, bao nhiêu, mua ở đâu… (không bắt buộc)"
              maxLength={200}
              className="cho-o-them cho-o-ghi-chu"
            />
          ) : (
            <button type="button" className="cho-nut-chu" onClick={() => setMoGhiChu(true)}>
              + thêm ghi chú
            </button>
          )}
        </form>
      ) : (
        <p className="cho-khong-them">
          Bạn xem được danh sách và tick được món đã mua, nhưng chưa được thêm món mới.
          Nhờ người quản trị bật ô “Thêm” trong Quản lý thành viên.
        </p>
      )}

      {/* Hàng nút "hay mua". Máy chủ chỉ trả về món đã thêm từ HAI LẦN trở
          lên và KHÔNG đang nằm trong danh sách chưa mua — nên hàng này chỉ
          xuất hiện khi nó thật sự đáng xuất hiện, và không mời người ta
          tạo dòng trùng. Nhà đổi thói quen thì hàng nút tự đổi theo. */}
      {coTheThem && hayMua.length > 0 && (
        <div className="cho-hay-mua">
          <span className="cho-hay-mua-nhan">Hay mua:</span>
          {hayMua.map((h) => (
            <button
              key={h.ten_mon}
              type="button"
              className="cho-chip"
              onClick={() => themNhanh(h.ten_mon)}
              title={`Đã mua ${h.so_lan} lần — bấm để thêm vào danh sách`}
            >
              + {h.ten_mon}
            </button>
          ))}
        </div>
      )}

      {chuaMua.length === 0 && daMua.length === 0 && (
        <p className="cho-trong">
          Chưa có gì trong danh sách. Trong tuần ai thấy hết gì thì thêm một dòng —
          chủ nhật ai đi chợ mở ra là đủ.
        </p>
      )}

      <KhoiMon tieuDe="Cần mua" ds={chuaMua} veDong={veDong} />
      <KhoiMon
        tieuDe="Đã mua"
        ds={daMua}
        lop="cho-khoi-xong"
        veDong={veDong}
        ghiChuCuoi="Món đã mua tự ẩn khỏi đây sau một tuần. Không bị xóa mất."
      />

      {/* Thực đơn đặt SAU danh sách. Mua sắm là việc chính của trang này;
          thực đơn là thứ để liếc trong lúc lập danh sách — "tuần này có cá
          kho thì phải mua cá". Đặt nó lên trên thì cái đang gấp bị đẩy
          xuống dưới. */}
      <ThucDonTuan user={user} />
    </div>
  );
}

export default DiCho;
